export default __webpack_public_path__ + "static/media/pastaIcone.63dd4215.svg";